  <script lang="ts">
	//import {ASSET_URL} from "../config";
	import FileUploadBtn from "./FileUploadBtn.svelte";

	export let title = null;
	export let placeholder = "";

	export let errorClass;

	export let rows = 6;

	export let name;

</script>

 <div class="community-data-box">

	 {#if title}
	 <div class="box-header">
		 <h4>{title}</h4>
	 </div>
	 {/if}
	 <div class="box-content">

		 <div>
 <textarea class="custom-col-12" {rows} {placeholder}
		   {name} class:error={errorClass}
 ></textarea>
		 </div>
		 </div>
 </div>


<style lang="scss">

	.community-data-box{

		background:$secondary-color;
		padding:1.5rem;
		border-radius:9px;
		color: #F8F7F7!important;
		flex:1;


		.box-header{

			h4{
				margin:0;
				padding:0;
			}

			margin-bottom:1rem;

		}
	}


</style>
